import { h } from 'vue'
const Dialog = defineAsyncComponent(() => import('~/components/modals/Dialog'))

export default {
  computed: {
    isModal () {
      return this.component && this.component.initData && this.component.initData.modal
    },
    componentTrail () {
      if (this.component && this.component.initData && this.component.initData.trail) {
        return [...this.component.initData.trail, this.component]
      }
      return [this.component]
    }
  },
  methods: {
    showModal (name, component, options) {
      const $this = this
      let events
      let backgroundEvents
      if (options.events) {
        // Transform event names to Vue 3 format
        events = Object.fromEntries(
          Object.entries(options.events).map(([k, fn]) => [
            `on${k.charAt(0).toUpperCase()}${k.slice(1)}`,
            function () { fn(...arguments); $this.$modal.hide(name) }
          ])
        )
      } else {
        events = {}
      }
      if (options.backgroundEvents) {
        // Transform background event names to Vue 3 format
        backgroundEvents = Object.fromEntries(
          Object.entries(options.backgroundEvents).map(([k, fn]) => [
            `on${k.charAt(0).toUpperCase()}${k.slice(1)}`,
            function () { fn(...arguments) }
          ])
        )
      } else {
        backgroundEvents = {}
      }
      this.$modal.show({
        render() {
          return h(component, {
            ...options.props,
            onClose: () => {
              $this.$modal.hide(name)
            },
            ...events,
            ...backgroundEvents
          })
        }
      }, {
      }, {
        name,
        adaptive: options.adaptive ?? true,
        width: options.width || 800,
        height: options.height || 'auto',
        maxWidth: options.maxWidth || Infinity,
        maxHeight: options.maxHeight || Infinity,
        scrollable: options.scrollable || false,
        clickToClose: options.clickToClose ?? true
      }, {
        'before-close': (e) => { if (options.handlers && options.handlers['before-close']) options.handlers['before-close'](e) },
        'closed': (e) => { if (options.handlers && options.handlers['closed']) options.handlers['closed'](e) }
      })
    },
    hideModal (name) {
      this.$modal.hide(name)
    },
    showDialog (options) {
      this.$modal.show(Dialog, {
        options
      }, {
        name: 'dialog',
        adaptive: true,
        width: options.width || 600,
        height: options.height || 'auto',
        maxWidth: options.maxWidth || Infinity,
        maxHeight: options.maxHeight || Infinity,
        scrollable: options.scrollable || false,
        clickToClose: options.clickToClose ?? true
      }, options.onClosed ? { closed: options.onClosed } : {}) // onClosed: called however the dialog closes
    }
  }
}